<template>
    <div style="height: 100%;">
        <virtual-examine v-if="currentTab=='virtualExamine'"></virtual-examine>
        <theory-examine v-else-if="currentTab=='theoryExamine'"></theory-examine>
        <all-examine v-else-if="currentTab=='allExamine'"></all-examine>
    </div>
</template>

<script>
import AllExamine from './examineMag/AllExamine.vue'
import TheoryExamine from './examineMag/TheoryExamine.vue'
import VirtualExamine from './examineMag/VirtualExamine.vue'
    export default {
  components: { VirtualExamine, TheoryExamine, AllExamine },
        data(){
            return {
               
            }
        },
        computed:{
            /**当前tab */
            currentTab(){
                    return this.$store.state.backend.currentTab;
                }
        },
    }
</script>

<style lang="less" scoped>

</style>